import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import type { TemplateRef } from '@angular/core';
import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';

import type { AttributeListData } from '@core/http-types';
import type { ListTemplateContext } from '@core/user-interface-legacy';
import { AttributesComponent } from '@core/user-interface-legacy';

import type { DepartmentAttribute } from '../../types/departments.types';

@Component({
  selector: 'rt-department-select',
  templateUrl: './department-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AttributesComponent],
})
export class DepartmentSelectComponent {
  public readonly selected = input<DepartmentAttribute[]>([]);
  public readonly canCreate = input<boolean>(undefined!);
  public readonly suggestions = input<AttributeListData>(undefined!);
  public readonly dropdownPositions = input<ConnectionPositionPair[] | null>(undefined!);
  public readonly listTpl = input<TemplateRef<ListTemplateContext> | null>(undefined!);
  public readonly selectFooterTemplate = input<TemplateRef<any> | null>(undefined!);
  public readonly selectHeaderTemplate = input<TemplateRef<any> | null>(undefined!);
  public readonly toggleDropdown = input<boolean>(undefined!);
  public readonly hasTriggerWidth = input(true);
  public readonly markSelected = input(false);

  public query = output<string>();
  public select = output<DepartmentAttribute>();
  public remove = output<DepartmentAttribute>();
  public goToSettings = output<void>();
}
